import fetch from 'auth/FetchInterceptor';
import { API_BASE_URL } from 'configs/AppConfig';

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {FetchListParams} params
 * @returns {Promise<FetchClientListResponse>}
 */
export function requestOwnerList(params) {
    /**
     * @NOTE This limit is hard code for now because we need to implement the sorting nad filterting only at front end.
     *  In future we may remove it when sorting and filterting is implemented on backend
     */
    return fetch.get(`${BASE_URL}/api/app/owner`, {
        params: { limit: 10000 }
    });
}


/**
 *
 * @param {Owner} ownerData
 */
 export function requestCreateOwner(ownerData) {
    return fetch.post(`${BASE_URL}/api/app/owner`, {
        ...ownerData
    });
}

/**
 *
 * @param {Owner} ownerData
 */
export function requestUpdateOwner(ownerData) {
    const data = { ...ownerData };
    delete data['_id'];
    return fetch.put(`${BASE_URL}/api/app/owner/${ownerData._id}`, {
        ...data
    });
}